(function () {
    "use strict";
    
	var app = angular.module('cccu.universitySurveys', [
		'cccu.universitySurveys.surveys',
		'ui.router',
		'cccu.common.logging',
		'cccu.common.apiConfig'
	]);
    
    app.config(function ($stateProvider, $urlRouterProvider, $provide, $httpProvider) {
        $urlRouterProvider.otherwise('/surveys');
    });
    
/*    app.factory('UniversitySurveyService', ['$q', function ($q) {
		return {
			getSurveys : function () {
				return $q.when({
					'url': 'https://secure.test.canterbury.ac.uk/studentsurveyrouter/'
				});
			}
		};
	}]);*/
}());